import * as React from "react";
import { withApollo } from "react-apollo";

import { DatePicker } from "material-ui";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

import BODebounceInput from "app/components/BOComponents/BODebounceInput";
import AllRefundRequestsContainer from "app/components/AppComponents/RefundRequests/AllRefundRequestsContainer";

type Props = {
  setHeader: any;
  client: any;
  history: any;
};

type State = {
  id: string;
  status: string;
  created_at_from: string;
};

class RefundRequests extends React.Component<Props, State> {
  state = {
    id: null,
    status: "",
    created_at_from: null,
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Refund Request",
      description: "SnapScan refund request",
    });
  }

  handleDateChange = (event: any, date: Date): void => {
    this.setState({
      created_at_from: date.toISOString(),
    });
  };

  handleStatusChange = (e) => {
    this.setState({ status: e.target.value });
  };

  render() {
    return (
      <section className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DatePicker
            hintText="Date created"
            onChange={this.handleDateChange}
            style={{
              width: "300px",
              marginRight: "10px",
            }}
            textFieldStyle={{
              width: "200px",
            }}
          />
          <BODebounceInput
            style={{ width: "25%" }}
            debounceTimeout={300}
            placeholder="Search Refund by ID"
            onChange={(newValue) => {
              this.setState({ id: newValue });
            }}
          />
          <FormControl>
            <InputLabel id="select-label">Search Refunds by Status</InputLabel>
            <Select
              style={{
                width: "300px",
                marginRight: "10px",
              }}
              value={this.state.status}
              onChange={this.handleStatusChange}
            >
              <MenuItem value={""}>
                <em>All</em>
              </MenuItem>
              <MenuItem value={"pending"}>Pending</MenuItem>
              <MenuItem value={"completed"}>Completed</MenuItem>
              <MenuItem value={"errored"}>Errored</MenuItem>
            </Select>
          </FormControl>
        </div>

        <AllRefundRequestsContainer
          name={"fraud.refundrequest.list"}
          created_at_from={this.state.created_at_from}
          id={this.state.id}
          status={this.state.status}
        />
      </section>
    );
  }
}

export default withApollo(RefundRequests);
